/**
 * Toast API — fires events that <Toaster /> listens to.
 * Usage: `import { toast } from '@teivor/shared-ui'; toast.success('Saved');`
 */

export type ToastVariant = 'success' | 'warning' | 'danger' | 'info';

export interface ToastOpts {
  title?: string;
  duration?: number;
  action?: { label: string; onClick: () => void };
}

export interface ToastEvent extends ToastOpts {
  id: string;
  variant: ToastVariant;
  message: string;
}

const TOAST_EVENT = 'teivor:toast';

function emit(variant: ToastVariant, message: string, opts?: ToastOpts) {
  if (typeof window === 'undefined') return;
  const detail: ToastEvent = {
    id: `t_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`,
    variant,
    message,
    ...opts,
  };
  window.dispatchEvent(new CustomEvent<ToastEvent>(TOAST_EVENT, { detail }));
}

export const toast = {
  success(msg: string, opts?: ToastOpts) {
    emit('success', msg, opts);
  },
  error(msg: string, opts?: ToastOpts) {
    emit('danger', msg, opts);
  },
  warning(msg: string, opts?: ToastOpts) {
    emit('warning', msg, opts);
  },
  info(msg: string, opts?: ToastOpts) {
    emit('info', msg, opts);
  },
};

export const TOAST_EVENT_NAME = TOAST_EVENT;
